import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Logo } from '../components/Logo';
import { SearchBar } from '../components/SearchBar';
import { useCity } from '../contexts/CityContext';

export function CitySelectPage() {
  const { cities, selectCity } = useCity();
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  const filtered = cities.filter(c =>
    c.name.toLowerCase().includes(search.toLowerCase()) ||
    c.state.toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = (city) => {
    selectCity(city);
    navigate('/mapa');
  };

  return (
    <div className="nc-page">
      <div style={{ padding: 16, background: 'var(--nc-surface)', borderBottom: '1px solid var(--nc-border)' }}>
        <div style={{ marginBottom: 12 }}>
          <Logo size={32} />
        </div>
        <h2 style={{ fontSize: 18, fontWeight: 600, color: 'var(--nc-text)', marginBottom: 12 }}>
          Em qual cidade você está?
        </h2>
        <SearchBar
          placeholder="Buscar cidade..."
          value={search}
          onChange={setSearch}
        />
      </div>

      <div style={{ padding: 16 }}>
        <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--nc-text-muted)', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8 }}>
          Todas as cidades
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {filtered.map(city => (
            <button
              key={city.id}
              onClick={() => handleSelect(city)}
              style={{
                display: 'flex', alignItems: 'center', gap: 12, padding: 12, borderRadius: 10,
                background: 'var(--nc-surface)', border: '1px solid var(--nc-border)', textAlign: 'left',
                cursor: 'pointer', width: '100%'
              }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0d5c3b" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 14, fontWeight: 500, color: 'var(--nc-text)' }}>{city.name}</div>
                <div style={{ fontSize: 12, color: 'var(--nc-text-muted)' }}>{city.state}</div>
              </div>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 18l6-6-6-6" />
              </svg>
            </button>
          ))}
        </div>

        {filtered.length === 0 && (
          <div style={{ textAlign: 'center', padding: 32 }}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>🔍</div>
            <div style={{ fontSize: 14, color: 'var(--nc-text-secondary)' }}>Cidade não encontrada</div>
            <button className="nc-btn-primary" style={{ marginTop: 12 }}>
              Solicitar implantação
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
